import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagged = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.75 0C0.335786 0 0 0.335786 0 0.75V9.75V17H1.5V10.5H15.25C15.5157 10.5 15.7616 10.3594 15.8964 10.1303C16.0312 9.90131 16.0347 9.61807 15.9056 9.38577L13.608 5.25L15.9056 1.11423C16.0347 0.881934 16.0312 0.598688 15.8964 0.369654C15.7616 0.140621 15.5157 0 15.25 0H0.75ZM7.35355 7.75L11.3536 3.75L10.6464 3.0429L7 6.68934L5.35355 5.0429L4.64645 5.75L6.64645 7.75C6.74021 7.84377 6.86739 7.89645 7 7.89645C7.13261 7.89645 7.25979 7.84377 7.35355 7.75Z"
	})
});
export default SvgFlagged;
